import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

// fantaz dependencies
import { AppRouterPaths } from '@fantaz/core/router';
import { AuthServiceInjectionToken } from '@fantaz/shared/data-access/api';

@Injectable()
export class AuthGuard {
  #appRouterPaths = inject(AppRouterPaths);
  #authService = inject(AuthServiceInjectionToken);

  canActivate(): Observable<boolean> {
    return this.#authService.isLoggedIn().pipe(
      tap((isLoggedIn) => {
        if (!isLoggedIn) {
          const url = this.#appRouterPaths.resolve(
            this.#appRouterPaths.routes.auth +
              this.#appRouterPaths.routes.authSignIn,
          );

          url.searchParams.set('redirectTo', window.location.pathname);

          window.location.href = url.toString();
        }
      }),
    );
  }
}
